/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';
import { setField, makeTree } from '../helpers/savedSearches';

export const createGroup = createAsyncThunk(
  'savedSearches/createGroup',
  async (
    { groupName, searchId },
    {
      extra: { sdk, Logger, Toast },
      getState,
    },
  ) => {
    try {
      await sdk.savedSearches.createGroup(searchId, groupName);

      return { userId: getState().user._id };
    } catch (error) {
      Logger.error(new Error('Can not create group'), { error }, [
        'CreateSavedSearchGroupFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      Toast('Error creating group', { type: 'error' });

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    createGroup.pending,
    (state, { meta: { arg: { searchId } } }) => {
      state.tree = setField(state.tree, searchId, 'isBusy', true);
    },
  ).addCase(
    createGroup.fulfilled,
    (state, { payload: { userId }, meta: { arg: { searchId, groupName } } }) => {
      state.all = state.all.map((ss) => {
        if (ss._id !== searchId) return ss;
        const newPath = ss.path
          ? `${ss.path.substring(0, ss.path.lastIndexOf(NEW_PATH_DELIMITER))}${NEW_PATH_DELIMITER}${groupName}${NEW_PATH_DELIMITER}${ss.name}`
          : `${NEW_PATH_DELIMITER}${groupName}${NEW_PATH_DELIMITER}${ss.name}`;

        return { ...ss, path: newPath };
      });
      state.tree = makeTree(state.all, userId, state.searchQuery);
    },
  ).addCase(
    createGroup.rejected,
    (state, { error, meta: { arg: { searchId } } }) => {
      state.error = error;
      state.tree = setField(state.tree, searchId, 'isBusy', false);
    },
  );
};
